import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import { BasePage } from './../base.page';
import { finalize } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { shcAccessToken } from 'src/app/constants/general.constant';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { Platform, LoadingController, ToastController, AlertController, ModalController } from '@ionic/angular';
import { DeleteAccountModalComponent } from 'src/app/components/delete-account-modal/delete-account-modal.component';

@Component({
  selector: 'shc-settings',
  templateUrl: './settings.page.html',
  styleUrls: ['./settings.page.scss'],
})
export class SettingsPage extends BasePage implements OnInit {
  userId: number;
  language: string;
  notificationsEnabled: boolean;

  constructor(
    protected platform: Platform,
    protected userService: UserService,
    protected authService: AuthService,
    protected translate: TranslateService,
    private errorService: ErrorHandlerService,
    protected loadingCtrl: LoadingController,
    private router: Router,
    private storage: Storage,
    toastController: ToastController,
    private alertController: AlertController,
    private modalCtrl: ModalController
  ) {
    super(platform, userService, authService, translate, loadingCtrl, toastController);
  }

  ngOnInit() { }

  ionViewWillEnter() {
    this.user$.subscribe(
      user => {
        this.userId = user.id;
        this.language = user.locale;
        if (user.allow_notifications === 1) {
          this.notificationsEnabled = true;
        } else {
          this.notificationsEnabled = false;
        }
      }
    );
  }

  toggleNotifications($event) {
    this.userService.toggleNotification({ allow_notifications: $event.target.checked ? 1 : 0 }).subscribe(
      res => {
        console.log(res);
        // this.user.allow_notifications = $event.target.checked;
      },
      error => {
        this.errorService.handle(error);
      }
    );
  }

  async deleteAccount() {
    const modal = await this.modalCtrl.create({
      component: DeleteAccountModalComponent,
      cssClass: 'delete-account-modal',
      canDismiss: true,
      backdropDismiss: true,
      keyboardClose: true,
      id: 'deleteAccount'
    });
    modal.onDidDismiss().then((data) => {
      if (data && data.data === true) {
        this.removeAccount();
      }
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  setLanguage(locale): string {
    if (locale === 'en') {
      return 'English';
    } else if (locale === 'nl') {
      return 'Dutch';
    }
  }

  removeAccount() {
    // this.router.navigate(['auth/login'], { replaceUrl: true });
    this.showLoader();
    this.userService
      .removeAccount(this.user.id)
      .pipe(finalize(() => this.hideLoader()))
      .subscribe(
        () => {
          this.translate.use('nl');
          this.storage.remove(shcAccessToken);
          this.loggedIn = false;
          this.router.navigate(['auth/login'], { replaceUrl: true });
        },
        error => this.errorService.handle(error)
      );
  }

}
